/**
 * Creates a unique deduplication key from metric name and tags with timestamp window
 */
export function createDeduplicationKey(name: string, tags?: Record<string, string>): string {
  const timeWindow = Math.floor(Date.now() / 500) * 500

  if (!tags) {
    return `${name}-${timeWindow}`
  }

  const sortedTags = Object.keys(tags)
    .sort()
    .map((key) => `${key}:${tags[key]}`)
    .join('|')

  return `${name}-${sortedTags}-${timeWindow}`
}
